import React from 'react';
import PropTypes from 'prop-types';
import {Text} from './Text';
import moment from 'moment';

const makeTimeDateCell = propName => {
  const component = ({row}) => {
    const d = moment.utc(row[propName]);
    return (
      <div style={{display: 'flex', flexDirection: 'row'}}>
        <Text style={{marginRight: '16px', color: 'black'}}>{d.format('HH:mm:ss')}</Text>
        <Text style={{color: 'black'}}>{d.format('DD/MM/YY')}</Text>
      </div>
    );
  };

  component.propTypes = {
    row: PropTypes.shape({
      [propName]: PropTypes.string,
    }),
  };

  return component;
};

export default makeTimeDateCell;
